import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-candidate-form-tabs',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="candidate-form-tabs">
      <!-- Placeholder for candidate form tabs -->
      <p>Candidate Form Tabs Component</p>
      <button (click)="onSubmit()">Submit</button>
      <button (click)="onCancel()">Cancel</button>
    </div>
  `,
  styles: [`
    .candidate-form-tabs {
      padding: 20px;
      border: 1px solid #ddd;
      border-radius: 4px;
    }
  `]
})
export class CandidateFormTabsComponent {
  @Output() onFormSubmit = new EventEmitter<any>();
  @Output() onFormCancel = new EventEmitter<void>();

  onSubmit() {
    this.onFormSubmit.emit({});
  }

  onCancel() {
    this.onFormCancel.emit();
  }
}